import { render, staticRenderFns } from "./ProductSearchAndAdder.vue?vue&type=template&id=7643d652&scoped=true"
import script from "./ProductSearchAndAdder.vue?vue&type=script&lang=js"
export * from "./ProductSearchAndAdder.vue?vue&type=script&lang=js"
import style0 from "./ProductSearchAndAdder.vue?vue&type=style&index=0&id=7643d652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7643d652",
  null
  
)

export default component.exports